import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/workpath0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground } from 'docz';
import ReactAnsi from '../src/index.tsx';
import RealTime from './realtime.tsx';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "realtime"
    }}>{`Realtime`}</h1>
    <Playground __position={0} __code={'<RealTime>\n  {({ log }) => (\n    <ReactAnsi\n      log={log}\n      bodyStyle={{ maxHeight: 300, overflowY: \'auto\' }}\n      autoScroll\n    />\n  )}\n</RealTime>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      ReactAnsi,
      RealTime
    }} mdxType="Playground">
  <RealTime mdxType="RealTime">
    {({
          log
        }) => <ReactAnsi log={log} bodyStyle={{
          maxHeight: 300,
          overflowY: 'auto'
        }} autoScroll mdxType="ReactAnsi" />}
  </RealTime>
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      